const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const colorTextDestructive = 'var(--colorTextDestructive, var(--coreColorRed700))'
import { useSelector } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'
import { Button } from '@calendly/ui/components/button'

import { useI18n } from 'locales'
import { selectedSpotsSelector } from 'selectors/calendar'

import InviteeVoteAvatars from './invitee_vote_avatars'
import _NextButton from "action_bar-NextButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/action_bar.js?styleId=NextButton";
import _ButtonContainer from "action_bar-ButtonContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/action_bar.js?styleId=ButtonContainer";
import _TextContainer from "action_bar-TextContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/action_bar.js?styleId=TextContainer";
import _ErrorTextContainer from "action_bar-ErrorTextContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/action_bar.js?styleId=ErrorTextContainer";



const NextButton = /*#__PURE__*/styled(Button, null, {
  displayName: "NextButton",
  styles: _NextButton,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const ButtonContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
})

const TextContainer = /*#__PURE__*/styled('div', null, {
  displayName: "TextContainer",
  styles: _TextContainer,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const ErrorTextContainer = /*#__PURE__*/styled(TextContainer, null, {
  displayName: "ErrorTextContainer",
  styles: _ErrorTextContainer
})

const ActionBar = ({ onConfirm }) => {
  const { i18n } = useI18n()
  const showSpotSelectionError = useSelector((state) => state.calendar.showSpotSelectionError)
  const selectedSpots = useSelector(selectedSpotsSelector)

  return (
    <>
      <InviteeVoteAvatars />
      {
        showSpotSelectionError
          ? (
            <ErrorTextContainer>
              {i18n.t('booking.templates.times_selected_error')}
            </ErrorTextContainer>
          )
          : (
            <TextContainer>
              {i18n.t('booking.templates.times_selected', { count: selectedSpots.length })}
            </TextContainer>
          )
      }
      <ButtonContainer>
        <NextButton
          onClick={onConfirm}
        >
          {i18n.t('booking.action.next')}
        </NextButton>
      </ButtonContainer>
    </>
  )
}

export default ActionBar
